import React, { Component } from 'react'
import { Alert } from 'reactstrap'

import { auth } from '../../firebase'
import * as layout from '../../constants/layout'

import { FormularLeft, InputTop, InputBottom } from '../StyledComponents/Authentication'
import { DivWithMargin } from '../StyledComponents/Fillers'

const byPropKey = (propertyName, value) => () => ({
    [propertyName]: value,
})

const INITIAL_STATE = {
    passwordOne: '',
    passwordTwo: '',
    error: null,
}

class PasswordChangeForm extends Component {
    constructor(props) {
        super(props)

        this.state = { ...INITIAL_STATE }
    }

    onSubmit = (event) => {
        const { passwordOne } = this.state

        auth.doPasswordUpdate(passwordOne)
            .then(() => {
                this.setState(() => ({ ...INITIAL_STATE }))
            })
            .catch((error) => {
                this.setState(byPropKey('error', error))
            })

        event.preventDefault()
    }

    render() {
        const {
            passwordOne,
            passwordTwo,
            error,
        } = this.state

        const isInvalid =
            passwordOne !== passwordTwo ||
            passwordOne === ''

        return (
            <FormularLeft className="onLeft text-center" onSubmit={this.onSubmit}>
                <label htmlFor="inputPassword" className="sr-only">Email address</label>
                <InputTop
                    value={passwordOne}
                    onChange={event => this.setState(byPropKey('passwordOne', event.target.value))}
                    type="password"
                    placeholder="New Password"
                    id="inputPassword"
                    className="form-control"
                    required
                />
                <label htmlFor="confirmInputPassword" className="sr-only">Email address</label>
                <InputBottom
                    value={passwordTwo}
                    onChange={event => this.setState(byPropKey('passwordTwo', event.target.value))}
                    type="password"
                    placeholder="Confirm New Password"
                    id="confirmInputPassword"
                    className="form-control"
                    required
                />
                <button className="btn btn-primary btn-block" disabled={isInvalid} type="submit">
                    Reset My Password
                </button>

                { error && <DivWithMargin top={layout.MARGIN_TOP} bottom={layout.MARGIN_BOTTOM}><Alert color="danger">{error.message}</Alert></DivWithMargin> }
            </FormularLeft>
        )
    }
}

export default PasswordChangeForm



// WEBPACK FOOTER //
// ./src/components/userManagement/PasswordChange.js